/**
 * Formats a phone number with dashes (###-###-####)
 *
 * @param {string | null | undefined} phoneNumber - A number that needs to be
 *   formatted
 * @returns {string} A string formatted as ###-###-####
 */
export const formatPhoneNumber = (phoneNumber?: string | null): string => {
  if (
    phoneNumber === null ||
    phoneNumber === undefined ||
    typeof phoneNumber !== 'string' ||
    phoneNumber.trim() === ''
  )
    return ''

  // Remove non-numeric characters
  const digits = phoneNumber.replace(/\D/g, '')

  // Ensure it's exactly 10 digits
  if (digits.length !== 10) return phoneNumber

  return digits.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
}
